"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Others = _interopRequireDefault(require("@rsuite/icon-font/lib/application/Others"));

// Generated by script, don't edit it please.
var Others = (0, _createSvgIcon["default"])({
  as: _Others["default"],
  ariaLabel: 'others',
  category: 'application',
  displayName: 'Others'
});
var _default = Others;
exports["default"] = _default;
module.exports = exports.default;